import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from '../../services/permission.service';
import { MdlChangestatuscomponent } from '../../components/mdl-change-taskStatus/mdl-change-taskStatus';
import { MDLModifyTask } from '../../components/mdl-modify-task/mdl-modify-task';
import { MdlDeleteTask } from '../../components/mdl-delete-task/mdl-delete-task';

@Component({
  selector: 'app-task-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
  ],
  templateUrl: './task-detail.html',
  styleUrl: './task-detail.css',
})
export class TaskDetail implements OnInit {
  public tarea: any = {};
  public asociado: any = {};
  public api = inject(Api);
  public isLoading: boolean = true;
  public errorMessage: string = '';
  showRecentDropdown: boolean = false;
  openedMenuId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public permissionService: PermissionService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    private dialog: MatDialog
  ) {
      this.route.params.subscribe(params => {
      const taskId = params['id'];
      if (taskId) {
        this.cargarTarea(taskId);
      } else {
        this.errorMessage = 'No se proporcionó un ID de tarea válido';
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {
  }

  cargarTarea(id: string): void {
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getTaskbyId(id).subscribe({
      next: (data: any) => {
        this.tarea = data.tarea;
        this.asociado = data.asociado;
        this.isLoading = false;
        console.log('tarea:',this.tarea)
        setTimeout(() => {
          this.api.hideLoading();
        }, 500);
      },
      error: (err: any) => {
        console.error('Error en API:', err);

        if (err.status === 403) {
          this.errorMessage = 'No tienes permiso para ver esta tarea.';
          this.router.navigateByUrl('/tasks');
        } else {
          this.errorMessage = 'Error al cargar la tarea.';
        }

        this.isLoading = false;
        this.api.hideLoading();
      },
    });

  }


  
  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  
    openmdlchangeStatus(tarea:any){
        this.dialog.open(MdlChangestatuscomponent,{
        minWidth: '500px',
        maxHeight: '330px',
        panelClass: 'mat-dlg-class',
        data:{
          tarea_id:tarea.tarea_id,
          mode:'estado',
          
        }
      }).afterClosed().subscribe(() => {
        this.cargarTarea(tarea.tarea_id);
      });
      
    }
  
  
    openmdlchangePriority(tarea:any){
        this.dialog.open(MdlChangestatuscomponent,{
        minWidth: '500px',
        maxHeight: '330px',
        panelClass: 'mat-dlg-class',
        data:{
          tarea_id:tarea.tarea_id,
          mode:'prioridad',
  
        }  
      }).afterClosed().subscribe(() => {
        this.cargarTarea(tarea.tarea_id);
      });
  }

  openmdlmodifyTask(tarea:any){
        this.dialog.open(MDLModifyTask,{
          minWidth: '800px',
          maxHeight: '900px',
          panelClass: 'mat-dlg-class',
        data:{
          taskData:tarea,
  
        }  
      }).afterClosed().subscribe(() => {
        this.cargarTarea(tarea.tarea_id);
      });
  }

  openmdldeleteTask(tarea:any){
    this.dialog.open(MdlDeleteTask,{
          minWidth: '800px',
          maxHeight: '900px',
          panelClass: 'mat-dlg-class',
          data:{
            tarea_id:tarea.tarea_id,
            mode:'task'

          }
    }).afterClosed().subscribe(() => {
        this.router.navigateByUrl('/tasks');
      });
  }
  
}
